import FrontApplet from '../FrontApplet/FrontApplet';
import { TimingLoaded } from './Timing/timingCommands';
import { ITypedCommandEvent } from '../FrontApplet/Command/ICommandEvent';
import ICommand from '../FrontApplet/Command/ICommand';
import { handleFileSystemRequests } from './FileSystem/handleFileSystemRequests';
import { handleHtmlSnapshotTakingRequests } from './Html/handleHtmlSnapshotTakingRequests';
import { handleOfflineCacheRequests } from './Offline/Cache/handleOfflineCacheRequests';
import { handleVideoRequests } from './Video/handleVideoRequests';
import { handleOSDRequests } from './OSD/handleOsdRequests';
import { handleManagementApplicationRequests } from './Management/App/handleApplicationRequests';
import { handleManagementPowerRequests } from './Management/Power/handlePowerRequests';
import { handleDisplayRequests } from './Display/handleDisplayRequests';
import { ConsoleLogged } from './Console/consoleCommands';
import { handleManagementRequests } from './Management/handleManagementRequests';
import { handleManagementScreenRequests } from './Management/Screen/handleScreenRequests';
import { handleManagementSecurityRequests } from './Management/Security/handleSecurityCommands';
import { handleManagementAudioRequests } from './Management/Audio/handleAudioRequests';
import { handleManagementRemoteControlRequests } from './Management/RemoteControl/handleRemoteControlRequests';
import { handleManagementDebugRequests } from './Management/Debug/handleDebugRequests';
import { handleManagementOsRequests } from './Management/Os/managementOsRequests';
import { handleMonitoringRequests } from './handleMonitoringRequests';
import { handleManagementTimeCommands } from './Management/Time/handleTimeCommands';
import { handleManagementNativeCommandsMdcRequests } from './NativeCommands/handleNativeCommands';
import { handleManagementNetworkRequests } from './Management/Network/handleManagementNetworkRequests';
import { handleManagementPeerRecoveryRequests } from './Management/PeerRecovery/handlePeerRecoveryRequests';
import { handleManagementAutoRecoveryRequests } from './Management/AutoRecovery/handleAutoRecoveryRequests';
import { enhanceStandardConsoleLogging } from '../Util/Console/enhancer';
import { handleDeviceInfoRequests } from './DeviceInfo/handleDeviceInfoRequests';

export default class Monitoring {
	/** @internal */
	constructor(private frontApplet: FrontApplet) {
		this.interceptConsoleLogging();
		void this.handleTimingLoaded();
		handleMonitoringRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleHtmlSnapshotTakingRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleOfflineCacheRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleVideoRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleFileSystemRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleOSDRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementApplicationRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementPowerRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleDisplayRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementScreenRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementSecurityRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementAudioRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementRemoteControlRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementDebugRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementOsRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementTimeCommands(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementNativeCommandsMdcRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementNetworkRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementPeerRecoveryRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleManagementAutoRecoveryRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
		handleDeviceInfoRequests(this.onCommand.bind(this), this.dispatch.bind(this), this.frontApplet);
	}

	private onCommand<TCommand extends ICommand>(listener: (command: ITypedCommandEvent<TCommand>) => void) {
		this.frontApplet.command.onCommand((command) => {
			if (typeof this.frontApplet.config === 'object' && this.frontApplet.config.sosMonitoring) {
				listener(command as ITypedCommandEvent<TCommand>);
			}
		});
	}

	private async dispatch<TCommand extends ICommand>(command: TCommand) {
		if (typeof this.frontApplet.config === 'object' && this.frontApplet.config.sosMonitoring) {
			await this.frontApplet.command.dispatch<TCommand>(command);
		}
	}

	private async handleTimingLoaded() {
		await this.frontApplet.onReady();
		await this.dispatch<TimingLoaded>({ type: TimingLoaded });
	}

	private interceptConsoleLogging() {
		enhanceStandardConsoleLogging((type, ...args) => {
			void this.dispatch<ConsoleLogged>({
				type: ConsoleLogged,
				level: type,
				messages: args,
			});
		});
	}
}
